"use client";

import React from "react";
import {AnimatePresence, motion} from "framer-motion";
import {useTranslation} from "react-i18next";
import Icon from "../../library/Icon";

interface QueuedMessageBannerProps {
   message: string | null;
   onClear: () => void;
}

const QueuedMessageBanner: React.FC<QueuedMessageBannerProps> = ({message, onClear}) => {
   const {t: ct} = useTranslation("common");
   const displayText = message && message.length > 80 ? message.slice(0, 80) + "..." : message;

   return (
      <AnimatePresence>
         {message !== null && (
            <motion.div
               key="queued-message"
               initial={{opacity: 0, height: 0}}
               animate={{opacity: 1, height: "auto"}}
               exit={{opacity: 0, height: 0}}
               transition={{duration: 0.2, ease: "easeInOut"}}
               className="p-2"
            >
               <div className="flex items-center gap-2 px-3 py-1.5 text-sm text-700 border border-border rounded-full w-fit">
                  <Icon icon="clock" className="text-xs text-500 shrink-0" />
                  <span className="truncate min-w-0">
                     {message ? (
                        <>
                           {ct("queuedMessage")}
                           <span className="text-500 ml-1">{displayText}</span>
                        </>
                     ) : (
                        ct("queuedFiles")
                     )}
                  </span>
                  <button
                     type="button"
                     onClick={onClear}
                     className="shrink-0 p-0.5 rounded hover:bg-200 transition-colors"
                     aria-label={ct("clearQueuedMessage")}
                  >
                     <Icon icon="xmark" className="text-xs text-500" />
                  </button>
               </div>
            </motion.div>
         )}
      </AnimatePresence>
   );
};

export default QueuedMessageBanner;
